import { useStore } from 'react-redux';

import {
  selectPaletteTab,
  setPaletteTab as setPaletteTabAction,
  setToolboxTab as setToolboxTabAction,
  useToolboxState,
} from 'craft/state';
import { ToolboxTabs } from 'craft/types';

import { useShortcutQueries } from './useShortcutQueries';

const ELEMENTS_TO_IGNORE = ['input', 'textarea', 'select'];

const shouldIgnore = () => {
  if (!(document.activeElement instanceof HTMLElement)) {
    return false;
  }

  return (
    document.activeElement.isContentEditable ||
    ELEMENTS_TO_IGNORE.includes(document.activeElement.tagName.toLowerCase())
  );
};

export const useMenuShortcuts = () => {
  const { isInFocusMode } = useShortcutQueries();
  const store = useStore();
  const { setDockedState } = useToolboxState();
  const togglePaletteTab = (tab?: string) => () => {
    const currentPalette = selectPaletteTab(store.getState());
    if (currentPalette === tab) {
      store.dispatch(setPaletteTabAction(undefined));
    } else {
      store.dispatch(setPaletteTabAction(tab));
    }
  };

  const setToolboxTab = (tab: ToolboxTabs) => () => {
    store.dispatch(setToolboxTabAction(tab));
    setDockedState(false);
  };
  const enabled = () => !isInFocusMode() && !shouldIgnore();
  const shortcut = (...hotkeys: string[]) => ({ hotkeys, enabled });

  return {
    keyMap: {
      /** Arrow key navigation */
      shortcutPanel: shortcut('?', 'shift+?'),
      layoutMenu: shortcut('l'),
      typographyMenu: shortcut('t'),
      containerMenu: shortcut('n'),
      elementMenu: shortcut('e'),
      mediaMenu: shortcut('m'),
      objectMenu: shortcut('o'),
      /* toolbox */
      component: shortcut('c'),
      interactions: shortcut('i'),
      placements: shortcut('p'),
      styles: shortcut('s'),
    },
    handlers: {
      shortcutPanel: togglePaletteTab('Shortcuts'),
      layoutMenu: togglePaletteTab('Layout'),
      typographyMenu: togglePaletteTab('Text'),
      containerMenu: togglePaletteTab('Containers'),
      elementMenu: togglePaletteTab('Element'),
      mediaMenu: togglePaletteTab('Media'),
      objectMenu: togglePaletteTab('Object'),
      embedMenu: togglePaletteTab('Embed'),

      component: setToolboxTab(ToolboxTabs.Component),
      interactions: setToolboxTab(ToolboxTabs.Interactions),
      placements: setToolboxTab(ToolboxTabs.Placements),
    },
  };
};
